var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.isNavBarVisible)?_c('Navigation'):_vm._e(),_c('Header'),_c('v-main',{attrs:{"color":"#ebebeb"}},[_c('router-view')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }